import React, { useEffect } from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { makeStyles } from "@material-ui/core/styles";
import { useLocation } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {
  Card,
  CardActionArea,
  Divider,
  Grid,
  IconButton,
} from "@material-ui/core";
import CardBody from "components/Card/CardBody";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { Add } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    fontFamily: "Roboto, sans-serif",
  },
  activeCard: {
    backgroundColor: "#20677b",
    transition: "background-color 0.3s, border 0.3s",
    "& *": {
      color: "white !important",
    },
  },
  card: {
    borderRadius: theme.shape.borderRadius,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    boxShadow: theme.shadows[3],
  },
  cardTitle: {
    fontSize: "1.1rem",
    fontWeight: 500,
    marginBottom: theme.spacing(1),
    wordWrap: "break-word",
  },
  cardDescription: {
    fontSize: "0.9rem",
    color: theme.palette.text.secondary,
    wordWrap: "break-word",
  },
  iconContainer: {
    width: 50,
    height: 50,
    backgroundColor: theme.palette.grey[200],
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing(1),
  },
  gridContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(3),
    justifyContent: "space-evenly",
  },
}));

export default function DeliverableTiles(props) {
  const search = useLocation().search;
  const stage = new URLSearchParams(search).get("stage");
  const [selected, setSelected] = React.useState(props.active);

  // Update selected when props.active changes
  React.useEffect(() => {
    setSelected(props.active);
  }, [props.active]);

  const handleChange = (active) => {
    setSelected(active);
  };

  const classes = useStyles();
  const { tabs } = props;

  const numberOfTabs = tabs.length;

  const tabWidth = 12 / numberOfTabs;
  const tabSpacing = 1;

  const tabButtons = (
    <Grid container spacing={tabSpacing}>
      {tabs.map((prop, key) => (
        <Grid item xs={12} sm={6} md={6} lg={tabWidth} key={key}>
          <Card
            className={`${classes.card} ${
              selected === prop.heading ? classes.activeCard : ""
            }`}
          >
            <CardActionArea
              onClick={() => {
                handleChange(prop.heading);
                if (prop.onClick) {
                  prop.onClick(); // Call the onClick handler passed in props
                }
              }}
            >
              <CardBody>
                <Grid container>
                  <Grid
                    item
                    xs={2}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <prop.icon className={classes.tabIcon} />
                  </Grid>
                  <Grid item xs={8}>
                    <h4 className={classes.cardTitle}>
                      <b>{prop.heading}</b>
                    </h4>
                    <p>{prop.description}</p>
                  </Grid>
                  <Divider />
                </Grid>
              </CardBody>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  return <div>{tabButtons}</div>;
}

DeliverableTiles.defaultProps = {
  active: "Overview",
};

DeliverableTiles.propTypes = {
  active: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string.isRequired,
      icon: PropTypes.object.isRequired,
      description: PropTypes.string.isRequired,
      onClick: PropTypes.func, // onClick prop
    })
  ).isRequired,
};
